export type Duration = {
  days?: number;
  hours?: number;
  minutes?: number;
  seconds?: number;
  ms?: number;
};

export function duration({
  days = 0,
  hours = 0,
  minutes = 0,
  seconds = 0,
  ms = 0,
}: Duration) {
  const second = 1000;
  const minute = 60 * second;
  const hour = 60 * minute;
  const day = 24 * hour;

  return ms + seconds * second + minutes * minute + hours * hour + days * day;
}

export function getPartOfTime(
  time: number,
  part: 'seconds' | 'minutes' | 'hours' | 'days',
  floor?: boolean,
): number {
  let result = time;

  switch (part) {
    case 'seconds':
      result = (time / 1000) % 60;
      break;
    case 'minutes':
      result = (time / (1000 * 60)) % 60;
      break;
    case 'hours':
      result = (time / (1000 * 60 * 60)) % 24;
      break;
    case 'days':
      result = (time / (1000 * 60 * 60 * 24)) % 365;
      break;
  }

  if (floor) {
    result = Math.floor(result);
  }

  return result;
}
